import {
  ColorPicker,
  IconPicker,
} from '@supplement-bacon/react-toolkit/components'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form, Input, Switch } from 'antd'
import { requiredRule } from '../../../utils/rules'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="name" rules={[requiredRule()]} label={'Name'}>
        <Input />
      </Form.Item>
      <Form.Item name="icon" label="Icon">
        <IconPicker />
      </Form.Item>
      <Form.Item name="color" label="Color">
        <ColorPicker />
      </Form.Item>
      <Form.Item
        label="Default Status"
        name="isDefault"
        valuePropName="checked"
        initialValue={false}
      >
        <Switch />
      </Form.Item>
    </Form>
  )
}

export default Create
